'use client'

import { type ComponentProps, useRef } from 'react'
import { cn } from '@/lib/utils'

type ShadChatProps = ComponentProps<'div'>

const ShadChat = ({ className, children, ...props }: ShadChatProps) => {
  const chatRef = useRef<HTMLDivElement>(null)

  return (
    <div className={cn('h-[calc(100vh-9rem)] flex flex-col', className)} {...props}>
      <div ref={chatRef} className={cn('flex flex-col h-full', className)}>
        {children}
      </div>
    </div>
  )
}

const ShadChatHeader = ({ className, ...props }: ShadChatProps) => (
  <div className={cn('flex items-center justify-between p-4 border-b', className)} {...props} />
)

const ShadChatBody = ({ className, ...props }: ShadChatProps) => (
  <div className={cn('flex-1 overflow-y-auto min-h-0', className)} {...props} />
)

const ShadChatFooter = ({ className, ...props }: ShadChatProps) => (
  <div className={cn('border-t p-4', className)} {...props} />
)

export { ShadChat, ShadChatHeader, ShadChatBody, ShadChatFooter }
